module.exports = __webpack_public_path__ + "fc0f66c4db5c1a40f0a8c711d8c2d800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-1.jpg
// module id = 1111
// module chunks = 1